<template>
  <div class="tp-container">
    <div class="top-con">
      <div class="chart" ref="myChart"></div>
      <div
        class="circular"
        :style="{ border: '2px dashed ' + item.borderColor }"
        ref="circular"
      ></div>
    </div>
    <div class="name">
      {{ item.name }}
      <span ref="number">{{ item.number }}</span>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      item: {
        type: Object,
        default() {
          return {}
        },
      },
    },
    data() {
      return {}
    },
    mounted() {
      this.$nextTick(() => {
        this.init()
      })
    },
    beforeDestroy() {
      this.$animejs.remove([this.$refs.circular, this.$refs.number])
    },
    methods: {
      init() {
        let chartDom = this.$refs.myChart
        let myChart = this.$echarts.init(chartDom)
        let option = (option = {
          title: {
            text:
              Math.floor((this.item.number / this.item.total) * 100).toFixed(
                0
              ) + '%',
            subtext: '',
            x: 'center',
            y: 'center',
            textStyle: {
              color: '#fff',
              fontSize: 18,
              fontWeight: 'normal',
            },
          },
          legend: {
            x: 'center',
            y: 'bottom',
            data: ['rose3', 'rose5', 'rose6', 'rose7', 'rose8'],
          },
          series: [
            {
              name: '面积模式',
              type: 'pie',
              radius: [45, 51],
              center: ['50%', '50%'],
              labelLine: {
                show: false,
              },
              data: [
                {
                  value: this.item.number,
                  itemStyle: {
                    color: new this.$echarts.graphic.LinearGradient(
                      0,
                      1,
                      0,
                      0,
                      [
                        {
                          offset: 0,
                          color: this.item.color,
                        },
                        {
                          offset: 1,
                          color: this.item.color,
                        },
                      ]
                    ),
                  },
                },
                {
                  value: this.item.total,
                  name: 'rose2',
                  itemStyle: {
                    color: 'transparent',
                  },
                },
              ],
            },
            {
              name: '面积模式',
              type: 'pie',
              radius: [46, 49],
              center: ['50%', '50%'],
              labelLine: {
                show: false,
              },
              data: [
                {
                  value: this.item.number,
                  itemStyle: {
                    color: 'transparent',
                  },
                },
                {
                  value: this.item.total,
                  name: 'rose2',
                  itemStyle: {
                    color: '#272A2C',
                  },
                },
              ],
            },
          ],
        })
        myChart.setOption(option)
        this.$animejs({
          targets: this.$refs.circular,
          easing: 'linear',
          loop: true,
          rotate: 360,
          duration: 6000,
        })
        // 数字滚动动画
        this.$animejs({
          targets: this.$refs.number,
          innerHTML: [0, this.item.number],
          cycles: 130,
          round: 1,
          easing: 'linear',
        })
      },
    },
  }
</script>
<style lang="scss" scoped>
  .tp-container {
    .top-con {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: row;
      width: 5.7291vw;
      height: 5.7291vw;
      .chart {
        width: 5.7291vw;
        height: 5.7291vw;
      }
      .circular {
        position: absolute;
        left: 15px;
        top: 15px;
        bottom: 15px;
        right: 15px;
        border: 2px dashed #02ffa3;
        border-radius: 50%;
      }
      .number {
        position: absolute;
        z-index: 9;
        font-size: 1.1458vw;
        color: white;
      }
    }
    .name {
      font-size: 14px;
      color: #e6e6e6;
      text-align: center;
      margin-top: 0.52083vw;
      span {
        margin-left: 4px;
        color: white;
        font-size: 1.1458vw;
      }
    }
  }
</style>
